
import * as search from './search';

export default {
    search
}
